// Tiny dev-only logger. In production builds (NODE_ENV === "production")
// all methods are no-ops so we don't ship console noise or accidentally leak
// diagnostic strings to the browser console for end users.
//
// Usage:
//   import { devLog } from "@/lib/devLog";
//   devLog.warn("[auth] session cache write failed", err);
const isDev = typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production";
const noop = () => {};
export const devLog = {
  debug: isDev ? console.debug.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
};
